import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Row, Col } from "antd";
import { linesToParagraphs } from "./Functions";

import RequestButton from './RequestButton';

// LandingMain component;
class LandingMain extends Component {
  static propTypes = {
    headerId: PropTypes.string.isRequired,
    subtitleId: PropTypes.string.isRequired
  };

  render() {
    return (
      <div className="container">
        <Row className="landing__content--header" type="flex" align="middle">
          <Col span={24}>
            <h1>
              <FormattedMessage
                id={this.props.headerId}
                defaultMessage="Solutions for advertisers and affiliate networks"
                description="landing h1"
              >
                {linesToParagraphs}
              </FormattedMessage>
            </h1>
            {/* <p className="subtitle">
              <FormattedMessage
                id={this.props.subtitleId}
                defaultMessage="based on the performance marketing model using machine learning technology"
                description="landing after h1"
              >
                {linesToParagraphs}
              </FormattedMessage>
            </p> */}
          </Col>
        </Row>
        {/*___________________________________________________*/}
        {/*________________B E N E F I T S____________________*/}
        {/*___________________________________________________*/}
        <Row
          className="landing__content--benefits"
          type="flex"
          justify="space-between"
          align="top"
        >
          {this.props.children}
        </Row>
        <Row
          className="landing__content--request-btn"
          type="flex"
          justify="end"
        >
          <Col span={24}>
            <RequestButton />
          </Col>
        </Row>
      </div>
    );
  }
}

export default LandingMain;



// WEBPACK FOOTER //
// ./src/components/landing/common/Main.js